import { inject, Injectable } from '@angular/core';

import { DialogComponent } from '@plugins/client/dialog/dialog.component';
import { DialogService } from '@plugins/client/dialog/dialog.service';
import { CommonDialogConfig } from '@plugins/client/dialog/types';

import { ToastComponent } from './toast.component';
import { COMMON_TOAST_CONFIG } from './tokens';
import { ToastData } from './types';

export abstract class ToastServiceToken {
  abstract show(data: ToastData, config: CommonDialogConfig): void;
  abstract clear(): void;
}

@Injectable({ providedIn: 'root' })
export class ToastService extends ToastServiceToken {
  #dialogService = inject(DialogService);
  #commonConfig = inject(COMMON_TOAST_CONFIG, { optional: true }) ?? {};

  #toastTimeout?: ReturnType<typeof setTimeout>;
  #toast: DialogComponent | null = null;

  show(data: ToastData, config: CommonDialogConfig = {}) {
    this.clear();
    const { dialog } = this.#dialogService.open<ToastComponent>(
      ToastComponent,
      data,
      { modal: false, ...this.#commonConfig, ...config },
    );
    this.#toast = dialog;

    if (data.closeTimeout) {
      this.#toastTimeout = setTimeout(() => {
        this.clear();
      }, data.closeTimeout);
    }
  }

  clear() {
    if (this.#toastTimeout) {
      clearTimeout(this.#toastTimeout as unknown as number);
    }
    this.#toast?.close();
    this.#toast = null;
  }
}

@Injectable({ providedIn: 'root' })
export class TestToastService extends ToastServiceToken {
  show(data: ToastData, config: CommonDialogConfig): void {
    return;
  }
  clear() {}
}
